import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { cmsClient } from "@/lib/cmsClient";
import type { SunProtectionSettings } from "../sun-protection-settings.types";
import { parseSunProtectionSettingsResponse } from "../mappers/sun-protection-settings.parse";
import GET_SUN_PROTECTION_PAGE_CONTENT from "../graphql/GetSunProtectionPageContent.graphql";

export function useSunProtectionPageContent() {
    const { data, loading } = useQuery<unknown>(
        GET_SUN_PROTECTION_PAGE_CONTENT,
        {
            client: cmsClient,
        },
    );

    const settings: SunProtectionSettings | undefined = useMemo(
        () => parseSunProtectionSettingsResponse(data),
        [data],
    );

    return { data: settings, loading };
}
